module.exports = __webpack_public_path__ + "static/media/CharityChoiceLogo-Flat-Comp.64220c0a.svg";